var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClipboard = function SvgClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.5 1.5a3 3 0 0 0-2.693 1.678q-.747.063-1.487.15c-1.497.173-2.57 1.46-2.57 2.929V19.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V6.257c0-1.47-1.073-2.756-2.57-2.93a49 49 0 0 0-1.487-.15A3 3 0 0 0 13.5 1.5zM6.493 4.817q.51-.059 1.022-.107A1.5 1.5 0 0 0 9 6h6a1.5 1.5 0 0 0 1.485-1.29q.512.048 1.022.107c.704.082 1.243.694 1.243 1.44V19.5a1.5 1.5 0 0 1-1.5 1.5H6.75a1.5 1.5 0 0 1-1.5-1.5V6.257c0-.746.54-1.358 1.243-1.44M9 4.5q.001-.215.056-.409A1.5 1.5 0 0 1 10.5 3h3A1.5 1.5 0 0 1 15 4.5z",
    clipRule: "evenodd"
  })));
};
export default SvgClipboard;